import React from "react";
import { foodCalculators } from "./ConstantsFoodCalculator";
import SharedHelmet from "../Helmet";
const TITLE = "Kalkulator Makanan";
const DESCRIPTION = "Jelajahi semua kalkulator makanan yang tersedia untuk konversi antar satuan makanan yang berbeda. Anda juga dapat menemukan kalkulator kalori, kalkulator protein, kalkulator karbohidrat, kalkulator lemak, kalkulator air, kalkulator vitamin, kalkulator mineral, kalkulator serat, kalkulator kolesterol, kalkulator gula, kalkulator natrium, kalkulator kafein, kalkulator alkohol, dan kalkulator lainnya yang berkaitan dengan makanan. Setiap kalkulator dilengkapi penjelasan lengkap cara penggunaannya, beserta contoh praktis untuk memudahkan pemahaman. Baik Anda ingin menghitung kalori makanan, mengetahui kebutuhan protein harian, atau mengonversi satuan makanan, Anda akan menemukan semua itu dan lebih banyak lagi di kalkulator makanan kami.";
const KEYWORDS = "Kalkulator Makanan";
const OG_URL = 'https://do-calculate.com/id/food-calculators/';
function CalculatorsList() {
  return (
    <div className="container ltr-container" style={{ direction: "ltr" }}>
      <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
      />
      <div>
        <h1 style={{ fontSize: "26px" }}>{TITLE}</h1>
        <hr />
        <div className="alert alert-secondary" role="alert">
          <p>{DESCRIPTION} </p>
        </div>
      </div>
      <hr />
      <table>
        <thead>
          <tr>
            <th>Kalkulator</th>
            <th>Deskripsi</th>
          </tr>
        </thead>
        <tbody>
          {foodCalculators.map((calculator, index) => (
            <tr key={index}>
              <td>
                <a href={calculator.link}>
                  {" "}
                  <h2 style={{ fontSize: "14px" }}>{calculator.name}</h2>{" "}
                </a>
              </td>
              <td>
                <p>{calculator.description}</p>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
      <br />
    </div>
  );
}
export default CalculatorsList;